<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>备案管理</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                                @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <div class="border-all">
                            <div class="all-title">产品备案</div>
                            <div class="all">
                                <div class="border-box">
                                    <div class="producat">
                                        <div class="p-col-25">产品名称</div>
                                        <div class="p-col-25">{{ dataList.productName }}</div>
                                        <div class="p-col-25">产品剂型/型号</div>
                                        <div class="p-col-25 right-border">{{ dataList.productSn }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">规格</div>
                                        <div class="p-col-25">{{ dataList.productSpecification }}</div>
                                        <div class="p-col-25">产品类别</div>
                                        <div class="p-col-25 right-border">{{ dataList.productCategory }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">产品适用范围</div>
                                        <div class="p-col-75 right-border">{{ dataList.businessScope }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">检验报告结论</div>
                                        <div class="p-col-25">合格</div>
                                        <div class="p-col-25">安全评价报告结论</div>
                                        <div class="p-col-25 right-border">合格</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-100 right-border">产品在华责任单位</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">名称</div>
                                        <div class="p-col-25">{{ dataList.unitName }}</div>
                                        <div class="p-col-25">地址</div>
                                        <div class="p-col-25 right-border">{{ dataList.address }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">联系人</div>
                                        <div class="p-col-25">{{ dataList.contact }}</div>
                                        <div class="p-col-25">联系电话</div>
                                        <div class="p-col-25 right-border">{{ dataList.contactPhone }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">工商营业执照号</div>
                                        <div class="p-col-25">{{ dataList.businessLicenseNum }}</div>
                                        <div class="p-col-25">进口产品报关单号</div>
                                        <div class="p-col-25 right-border">{{ dataList.importedProductsNum }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-100 right-border">产品实际生产企业</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">名称</div>
                                        <div class="p-col-25">{{ dataList.name }}</div>
                                        <div class="p-col-25">地址</div>
                                        <div class="p-col-25 right-border">{{ dataList.productAddress }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">卫生许可证号</div>
                                        <div class="p-col-75 right-border">{{ dataList.hygieneLicense }}</div>
                                    </div>
                                    <div class="producat">
                                        <div class="p-col-25">备案时间</div>
                                        <div class="p-col-75 right-border">{{ dataList.businessForm }}</div>
                                    </div>
                                    <div class="producat border-but">
                                        <div class="p-col-25">备注</div>
                                        <div class="p-col-75 right-border">{{ dataList.remark }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                total: 0,
                isActive: 3,
                queryParams: {
                    pageNum: 1,
                    pageSize: 15,
                },
                list: [{
                        text: '消毒服务机构',
                        id: 1
                    },
                    {
                        text: '消毒检测评价机构备案公示名单',
                        id: 2
                    }, {
                        text: '备案流程',
                        id: 3
                    }, {
                        text: '产品备案',
                        id: 4
                    }
                ],
                dataList: {}
            }
        },
        mounted() {
            this.getlist()
        },
        methods: {
            getlist() {
                this.$axios.get('/websiteData/links/getOne/' + this.$route.query.id).then(res => {
                    this.dataList = res.data.data;
                    console.log(this.dataList)
                })
            },
            listClick(id) {
                if (id == 1) {
                    this.$router.push({
                        path: '/listOf',
                    })
                } else if (id == 2) {
                    this.$router.push({
                        path: '/publicityList',
                    })
                } else if (id == 3) {
                    this.$router.push({
                        path: '/filingProcess',
                    })
                } else if (id == 4) {
                    this.$router.push({
                        path: '/productFiling',
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: justify;

                        ul {
                            li {
                                height: 41px;
                                line-height: 40px;
                                overflow: hidden;
                                position: relative;
                                background: url('../../../assets/image/line.gif') bottom repeat-x;

                                a {
                                    background: url('../../../assets/image/icons.gif') left center no-repeat;
                                    font-size: 14px;
                                    padding-left: 12px;
                                }

                                span {
                                    color: #999;
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .border-all {
                            padding: 10px 0;

                            .all-title {
                                text-align: center;
                                font-size: 18px;
                                font-weight: 700;
                            }

                            .all {
                                margin: 10px 10px;

                                .border-box {
                                    .producat {
                                        overflow: auto;
                                        display: flex;
                                        text-align: center;
                                        line-height: 35px;
                                        border-top: 1px solid #000;

                                        .p-col-25 {
                                            width: 25%;
                                            border-left: 1px solid #000;
                                        }

                                        .p-col-75 {
                                            width: 75.1%;
                                            border-left: 1px solid #000;
                                        }

                                        .p-col-100 {
                                            width: 100%;
                                            border-left: 1px solid #000;
                                        }

                                        .right-border {
                                            border-right: 1px solid #000;
                                        }
                                    }

                                    .border-but {
                                        border-bottom: 1px solid #000;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>